import { Instagram, Linkedin, Youtube } from "lucide-react";
import { CONTACT_EMAIL, CONTACT_PHONE, CONTACT_PHONE_DISPLAY } from "../config";
import { MaskedLines, Reveal } from "../components/Motion";
import { BookingButton } from "../components/Cta";
import { InquiryForm } from "../components/Inquiry";

export default function Contact() {
  return (
    <section className="contact-page section-pad" data-testid="contact-page">
      <Reveal className="contact-left">
        <p className="eyebrow">Contact</p>
        <h1>
          <MaskedLines lines={[<>Let&apos;s make</>, <em key="s">something real.</em>]} delay={0.2} />
        </h1>
        <p className="ph-intro">
          A sentence is enough to start. Send the brief below, write to us directly, or grab twenty minutes with the
          studio — whatever suits the stage you&apos;re at.
        </p>
        <div className="contact-line">
          <span className="cl-label">Write to us</span>
          <a className="big-mail" href={`mailto:${CONTACT_EMAIL}`} data-testid="contact-email-link">
            {CONTACT_EMAIL}
          </a>
        </div>
        <div className="contact-line">
          <span className="cl-label">Call us</span>
          <a className="big-mail" href={`tel:${CONTACT_PHONE}`} data-testid="contact-phone-link">
            {CONTACT_PHONE_DISPLAY}
          </a>
        </div>
        <div className="contact-line">
          <span className="cl-label">Talk to us</span>
          <BookingButton testid="contact-booking-button" />
        </div>
        <div className="contact-line">
          <span className="cl-label">Follow the work</span>
          <div className="footer-social">
            <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="contact-instagram-link">
              <Instagram size={17} />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn" data-testid="contact-linkedin-link">
              <Linkedin size={17} />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer" aria-label="YouTube" data-testid="contact-youtube-link">
              <Youtube size={17} />
            </a>
          </div>
        </div>
        <p className="contact-base">Pune, India · Working worldwide</p>
      </Reveal>
      <Reveal delay={0.15} className="contact-panel">
        <p className="eyebrow">Project brief</p>
        <InquiryForm idPrefix="contact" />
      </Reveal>
    </section>
  );
}
